<template>
  <div
    :class="['tee-card', pointerClass.pointer]"
    @click="cardClick"
  >
    <!-- Left Section / Top Section (Desktop) -->
    <div class="tee-card__info">
      <!-- Header: Time & Preferred Dot -->
      <div class="tee-card__header">
        <div class="tee-card__time" :class="{ 'tee-card__time--disabled': pointerClass.disabled }">
          <v-icon small :color="pointerClass.disabled ? '#94A3B8' : '#0F172A'" class="mr-1">
            mdi-clock-outline
          </v-icon>
          <span>{{ time }}</span>
        </div>
        <span v-if="prefered" class="tee-card__featured-badge" title="Preferred Tee Time">
          <v-icon x-small color="#D97706">mdi-star</v-icon>
        </span>
      </div>

      <!-- Pricing & Availability -->
      <div class="tee-card__details">
        <div class="tee-card__pricing-group">
          <!-- Main Price Display -->
          <div
            v-if="typePaid !== 1 && showPrice"
            class="tee-card__price"
          >
            <span class="tee-card__amount">${{ $uvHelper.formatNumber(total) }}</span>
            <span class="tee-card__currency">{{ mnd }}</span>
            
            <!-- Promo Strikethrough Price -->
            <span
              v-if="typePaid === 2 && isAdmin == false && showPromoPrice"
              class="tee-card__promo-price ml-2"
            >
              ${{ players * priceGlobal }} {{ mnd }}
            </span>
          </div>

          <!-- Golf Included Tag for Hotel -->
          <div v-else-if="typePaid === 1" class="tee-card__included">
            <v-icon small color="#059669" class="mr-1">mdi-check-circle</v-icon>
            <span>Included</span>
          </div>

          <!-- Per Player Subtitle (Only shown if needed or desktop) -->
          <div
            v-if="typePaid !== 1 && showPrice && players > 1"
            class="tee-card__per-player"
          >
            ${{ $uvHelper.formatNumber(price) }} / player
          </div>
        </div>

        <!-- Availability Badge -->
        <div class="tee-card__availability mt-1">
          <span
            v-if="privado || reservados >= personLimit || disponible < players"
            class="tee-badge tee-badge--unavailable"
          >
            Sold out
          </span>
          <span v-else class="tee-badge tee-badge--available">
            <span class="tee-badge__dot"></span>
            {{ disponible }} {{ disponible === 1 ? 'spot' : 'spots' }}
          </span>
        </div>
      </div>
    </div>

    <!-- Right Section / Bottom Section (Desktop) -->
    <div class="tee-card__action">
      <v-btn
        class="tee-card__btn"
        color="#0A5C36"
        dark
        rounded
        depressed
        small
        :disabled="pointerClass.disabled"
      >
        Reservar
        <v-icon right small>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "timeCard",
  components: {},
  props: [
    "time",
    "mnd",
    "price",
    "tarifaDocId",
    "players",
    "privado",
    "reservados",
    "prefered",
    "tarifaId",
    "priceGlobal",
    "isAdmin",
    "selectedDate",
    "showPromoPrice",
    "showPrice",
  ],
  data() {
    return {
      clicked: false,
      personLimit: 4,
      actualDate: moment(),
    };
  },
  methods: {
    init() {},
    cardClick() {
      this.clicked = true;
      let isPrefered = this.prefered;
      this.$emit(
        "clicked",
        this.$vnode.key,
        this.time,
        this.tarifaDocId,
        this.mnd,
        isPrefered
      );
      this.$store.commit("setPriceSelected", this.total);
      this.$store.commit("setMndSelected", this.mnd);
    },
  },
  computed: {
    total: function () {
      let total = this.price * this.players;
      if (total == 0) {
        total = "-";
      }
      return total;
    },
    disponible: function () {
      let disponible = this.personLimit - this.reservados;
      return disponible;
    },
    pointerClass: function () {
      let pointer = "cardEnable";
      let isDisabled = false;

      if (
        this.privado ||
        this.reservados >= this.personLimit ||
        this.disponible < this.players
      ) {
        pointer = "cardDisabled";
        isDisabled = true;
      } else if (this.prefered == true) {
        pointer = "cardPrefered";
      }

      return { pointer: pointer, disabled: isDisabled };
    },
    typePaid() {
      return this.$store.getters.getTypePaid;
    },
    globalPrice() {
      return this.$store.getters.getGlobalPrice;
    },
  },
  watch: {},
  mounted() {
    this.init();
  },
  created() {
    setInterval(() => {
      let fecha = new moment();
      this.actualDate = fecha;
    }, 1000);
  },
};
</script>

<style>
/* ========== Mobile-First Tee Time Card (Horizontal) ========== */
.tee-card {
  width: 100%;
  background: #FFFFFF;
  border: 1.5px solid #E2E8F0;
  border-radius: 16px;
  padding: 12px 16px;
  display: flex;
  flex-direction: row; /* Horizontal on mobile */
  justify-content: space-between;
  align-items: center;
  text-align: left;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  position: relative;
  margin-bottom: 8px; /* Spacing for list */
}

.tee-card:hover:not(.cardDisabled) {
  border-color: #10B981;
  box-shadow: 0 6px 18px -4px rgba(16, 185, 129, 0.2);
  transform: translateY(-2px);
}

.tee-card__info {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

/* Header */
.tee-card__header {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 2px;
}

.tee-card__time {
  display: flex;
  align-items: center;
  font-size: 1.15rem;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.2px;
}

.tee-card__time--disabled {
  color: #94A3B8;
}

.tee-card__featured-badge {
  margin-left: 8px;
  display: flex;
  align-items: center;
}

/* Details */
.tee-card__details {
  display: flex;
  flex-direction: column;
}

.tee-card__pricing-group {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
}

.tee-card__price {
  display: flex;
  align-items: baseline;
  gap: 3px;
  line-height: 1.2;
}

.tee-card__amount {
  font-size: 1.12rem;
  font-weight: 800;
  color: #0A5C36;
  letter-spacing: -0.3px;
}

.tee-card__currency {
  font-size: 0.7rem;
  font-weight: 700;
  color: #64748B;
  text-transform: uppercase;
}

.tee-card__promo-price {
  font-size: 0.75rem;
  color: #94A3B8;
  text-decoration: line-through;
  font-weight: 600;
}

.tee-card__included {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 700;
  color: #059669;
}

.tee-card__per-player {
  font-size: 0.7rem;
  color: #64748B;
  font-weight: 500;
  margin-left: 6px;
  display: none; /* Hide on mobile to save space */
}

/* Availability Badge */
.tee-card__availability {
  display: flex;
  align-items: center;
}

.tee-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  color: #059669;
}

.tee-badge--unavailable {
  color: #94A3B8;
}

.tee-badge__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #10B981;
  display: inline-block;
}

/* Right Section Action */
.tee-card__action {
  flex-shrink: 0;
  margin-left: 12px;
}

.tee-card__btn {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
}

/* ========== States ========== */
.cardActive {
  border-color: #059669 !important;
  background: #F0FDF4 !important;
  box-shadow: 0 0 0 2px #059669, 0 8px 20px -4px rgba(5, 150, 105, 0.25) !important;
  transform: translateY(-2px);
}

.cardActive .tee-card__amount {
  color: #047857 !important;
}

.cardEnable {
  cursor: pointer;
}

.cardPrefered {
  border-color: #F59E0B !important;
}

.cardDisabled {
  background: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  cursor: not-allowed !important;
  pointer-events: none;
  opacity: 0.6;
  box-shadow: none !important;
}

.noShow {
  display: none !important;
}

/* ========== Desktop / Tablet Adjustments ========== */
@media (min-width: 960px) {
  .tee-card {
    flex-direction: column;
    text-align: center;
    padding: 16px 12px;
    height: 100%;
    margin-bottom: 0;
  }

  .tee-card__info {
    align-items: center;
    width: 100%;
  }

  .tee-card__header {
    justify-content: center;
    margin-bottom: 8px;
  }

  .tee-card__details {
    align-items: center;
  }

  .tee-card__pricing-group {
    flex-direction: column;
    align-items: center;
  }
  
  .tee-card__promo-price {
    margin-left: 0;
    margin-top: 2px;
  }

  .tee-card__per-player {
    display: block; /* Show on desktop */
    margin-left: 0;
    margin-top: 2px;
  }

  .tee-card__availability {
    justify-content: center;
    margin-top: 8px;
  }
  
  .tee-card__action {
    margin-left: 0;
    margin-top: 12px;
    width: 100%;
  }
  
  .tee-card__btn {
    width: 100%;
  }
}
</style>
